/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Mininputrequired5Inputs */

const en_coinvestments_submitticketsize_modal_mininputrequired5 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Mininputrequired5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum is required`)
};

/**
* | output |
* | --- |
* | "Minimum is required" |
*
* @param {Coinvestments_Submitticketsize_Modal_Mininputrequired5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_mininputrequired5 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Mininputrequired5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Mininputrequired5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_mininputrequired5(inputs)
});
export { coinvestments_submitticketsize_modal_mininputrequired5 as "coInvestments_submitTicketSize_modal_minInputRequired" }